import React from 'react';
import { Icon } from '@chakra-ui/icons';
import { Color } from 'src/theme/color';

export const LinkIcon = ({ color, ...props }: any) => {
	return (
		<Icon
			width="15"
			height="15"
			viewBox="0 0 15 15"
			fill="none"
			{...props}
		>
			<path
				d="M6.20935 8.14063C6.47601 8.49713 6.81623 8.79211 7.20692 9.00556C7.59761 9.21901 8.02964 9.34595 8.4737 9.37775C8.91776 9.40955 9.36346 9.34548 9.78058 9.18988C10.1977 9.03428 10.5765 8.7908 10.8912 8.47594L12.754 6.61312C13.3196 6.02757 13.6325 5.24332 13.6255 4.42928C13.6184 3.61524 13.2919 2.83654 12.7162 2.26091C12.1406 1.68527 11.3619 1.35875 10.5479 1.35168C9.73381 1.34461 8.94956 1.65754 8.36401 2.22309L7.29599 3.28489"
				stroke={color ?? Color.BACKGROUND_TERTIARY}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.69319 6.89886C8.42653 6.54236 8.08632 6.24738 7.69563 6.03393C7.30493 5.82048 6.87291 5.69354 6.42885 5.66174C5.98479 5.62994 5.53908 5.69401 5.12196 5.84961C4.70484 6.00521 4.32606 6.24869 4.01132 6.56355L2.1485 8.42637C1.58296 9.01192 1.27002 9.79617 1.27709 10.6102C1.28417 11.4243 1.61069 12.2029 2.18632 12.7786C2.76196 13.3542 3.54065 13.6807 4.35469 13.6878C5.16873 13.6949 5.95299 13.3819 6.53854 12.8164L7.60034 11.7546"
				stroke={color ?? Color.BACKGROUND_TERTIARY}
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};
